//-- Copyright (c) 2021 TMT Insights Group, LLC
import styled from '@emotion/styled';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { DraggableColumnProps } from './DraggableColumn';
import { useMemo } from 'react';

const DraggableColumnContent = (props: DraggableColumnProps) => {
  const { checked, label, index, handleChange, sectionKey } = props as DraggableColumnProps;
  const content = useMemo(() => (
    <FormControlLabel
      label={label}
      control={
        <Checkbox
          checked={checked}
          onChange={(e) => {
            handleChange && handleChange(index, e.target.checked);
          }}
          name={label}
        />
      }
    />
  ), [label, handleChange, index, checked]);

  const icon = useMemo(() => (
      sectionKey !== 'available' && <DragIcon icon="grip" />
  ), [DragIcon, sectionKey])

  return (
    <Column>
      {content}
      {icon}
    </Column>
  );
};

export default DraggableColumnContent;

const Column = styled(FormGroup)`
  width: 100%;
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  border: none;
  padding: ${({ theme }) => theme.spacing(0.5, 1.5)};
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  column-gap: ${({ theme }) => theme.spacing(1)};
  justify-content: space-between;
  align-items: center;
  margin: ${({ theme }) => theme.spacing(0.5, 0)};
`;

const DragIcon = styled(PolarisIcon)`
  color: ${({ theme }) => theme.palette.text.disabled};
  width: 25px;
  height: 25px;
  opacity: 0.5;
`;